import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { DetalleCierreContenido } from "./components/DetalleCierreContenido";

class DetalleCierre extends Component {
    regresar = () => {
        this.props.history.push("/produccion-bodega/inventario");
    };

    render() {
        const { match } = this.props;

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "91vw", margin: "auto" }}
            >
                <CardForm
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Cierre de inventario"
                    col="12"
                >
                    <DetalleCierreContenido
                        cierreId={match.params.id}
                        regresar={this.regresar}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(DetalleCierre);
